module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/84e7bba015155cafe943e83d54c0c4de.png";